<template>
  <v-tooltip v-if="hasLocks" bottom open-delay="500">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        :color="lockColor"
        class="lock-badge-icon"
      >mdi-lock</v-icon>
    </template>
    <span>{{ lockTooltip }}</span>
  </v-tooltip>
</template>

<style scoped>
  .lock-badge-icon {
    margin: 0 2px;
  }
</style>

<script>
export default {
  name: 'LockBadge',

  props: {
    locks: {
      type: [Array, Object],
      default: () => []
    }
  },

  computed: {
    locksArray() {
      if (!this.locks) return []
      if (Array.isArray(this.locks)) return this.locks
      if (typeof this.locks === 'object') {
        // If the object itself IS a single lock (has 'mode' property), wrap in array
        if ('mode' in this.locks) return [this.locks]
        // Otherwise treat as indexed object of lock items
        const items = Object.values(this.locks).filter(v => v && typeof v === 'object' && 'mode' in v)
        return items
      }
      return []
    },

    hasLocks() {
      return this.locksArray.length > 0
    },

    lockColor() {
      if (!this.hasLocks) return 'grey'
      const mode = this.locksArray[0].mode
      switch (mode) {
        case 'parent':    return 'green'
        case 'shared':    return 'amber darken-1'
        case 'exclusive': return 'red'
        default:          return 'grey'
      }
    },

    lockTooltip() {
      if (!this.hasLocks) return ''
      const mode = this.locksArray[0].mode
      switch (mode) {
        case 'parent':    return this.$t('lock_mode_parent')
        case 'shared':    return this.$t('lock_mode_shared')
        case 'exclusive': return this.$t('lock_mode_exclusive')
        default:          return this.$t('lock_mode_unknown')
      }
    }
  }
}
</script>
